import type { OptionState } from '@openx/types/options.ts';
import { useMemo } from 'react';
import { useOptionsByPathQuery } from '../../../hooks/useOptionsByPathQuery.ts';

export const useDmpSegmentsOptionsFetch = (accountUid: string): OptionState => {
  const { data: { optionsByPath = [] } = {}, loading } = useOptionsByPathQuery({
    variables: {
      filter: { account_uid: accountUid ?? null },
      path: 'deal.package.targeting.audience.openaudience_custom',
    },
  });

  const list = useMemo(() => {
    if (!optionsByPath) {
      return [];
    }

    return optionsByPath.map(option =>
      option
        ? {
            id: option.id,
            name: option.name,
            ...option.extra,
          }
        : []
    );
  }, [optionsByPath]);

  const mapById = useMemo(() => {
    return list
      .map(option => ({ [option.id]: option }))
      .reduce((acc, curr) => {
        return Object.assign(acc, curr);
      }, {});
  }, [list]);

  return {
    list,
    loading,
    mapById,
  };
};
